<template>
  <div>
    <div>
      <b-form
        ref="form"
        :style="{height: trHeight}"
        class="repeater-form"
        @submit.prevent="repeateAgain"
      >

        <!-- Row Loop -->
        <b-container fluid>
        <b-row
          v-for="(item, index) in content.contacts"
          :id="item.id"
          :key="index"
          ref="row"
        >
          <b-col md='9'>
              <b-row>
                  <b-col md="6">
                    <b-form-group
                        label="Nama"
                    >
                        <b-form-input
                            type="text"
                            placeholder="Nama"
                            v-model="item.nama"
                        />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group
                        label="Type"
                    >
                        <v-select
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="options.contactType"
                        v-model="item.type"
                        />
                    </b-form-group>
                  </b-col>
              </b-row>
              <b-row>
                  <b-col md="6">
                    <b-form-group
                        label="Jabatan"
                    >
                        <b-form-input
                            type="text"
                            placeholder="Jabatan"
                            v-model="item.jabatan"
                        />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group
                        label="NIK"
                    >
                        <b-form-input
                            type="text"
                            placeholder="NIK"
                            v-model="item.nik"
                        />
                    </b-form-group>
                  </b-col>
              </b-row>
              <b-row>
                  <b-col md="6">
                    <b-form-group
                        label="Email"
                    >
                        <b-form-input
                            type="text"
                            placeholder="Email"
                            v-model="item.email"
                        />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group
                        label="Phone"
                    >
                        <b-form-input
                            type="text"
                            placeholder="Phone"
                            v-model="item.phone"
                        />
                    </b-form-group>
                  </b-col>
              </b-row>
              <b-row>
                  <b-col md="6">
                    <b-form-group
                        label="Telegram"
                    >
                        <b-form-input
                            type="text"
                            placeholder="@username"
                            v-model="item.telegram"
                        />
                    </b-form-group>
                  </b-col>
              </b-row>
          </b-col>
          <b-col md="3">
              <b-button
              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
              variant="outline-danger"
              class="mt-0 mt-md-2"
              size="sm"
              @click="removeItem(index)"
            >
              <feather-icon
                icon="XIcon"
                class="mr-25"
              />
              <span>Delete</span>
            </b-button>
          </b-col>
          
          <b-col cols="12">
            <hr>
          </b-col>
        </b-row>
        </b-container>

      </b-form>
    </div>
    <b-button
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="primary"
      @click="repeateAgain"
    >
      <feather-icon
        icon="PlusIcon"
        class="mr-25"
      />
      <span>Add New</span>
    </b-button>
  </div>
</template>

<script>
import {
  BForm, BFormGroup, BFormInput, BContainer, BRow, BCol, BButton,
} from 'bootstrap-vue'
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'


export default {
  props: {
      content: Object,
      options: Object,
  },
  components: {
    BForm,
    BContainer,
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormInput,
    vSelect,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      nextTodoId: 1,
    }
  },
  mounted() {
  },
  created() {
    window.addEventListener('resize', this.initTrHeight)
  },
  destroyed() {
    window.removeEventListener('resize', this.initTrHeight)
  },
  methods: {
    repeateAgain() {
      this.content.contacts.push({
        tempId: this.nextTodoId += this.nextTodoId,
      })

    },
    removeItem(index) {
      this.content.contacts.splice(index, 1)
      this.trTrimHeight(this.$refs.row[0].offsetHeight)
    },
    initTrHeight() {
      this.trSetHeight(null)
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.repeater-form {
  overflow: hidden;
  transition: .35s height;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>